import { Box, BoxProps } from '@mui/material';

const VectorLegends = (props: BoxProps): JSX.Element => {
  return (
    <Box {...props}>
      <svg
        width="87"
        height="80"
        viewBox="0 0 87 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_7470_122614)">
          <path
            d="M57.0006 63.0001L57.9951 64.1229L57.0006 63.0001ZM71.4559 4.34359C70.8172 3.81598 69.8717 3.90603 69.3441 4.54471L60.7462 14.9527C60.2186 15.5914 60.3087 16.5368 60.9474 17.0645C61.586 17.5921 62.5315 17.502 63.0591 16.8633L70.7017 7.6118L79.9532 15.2544C80.5919 15.782 81.5374 15.6919 82.065 15.0533C82.5926 14.4146 82.5026 13.4691 81.8639 12.9415L71.4559 4.34359ZM4.99969 73.5013C4.78461 74.9858 4.78511 74.9858 4.78574 74.9859C4.78613 74.986 4.7869 74.9861 4.78767 74.9862C4.78922 74.9864 4.79129 74.9867 4.79389 74.9871C4.79908 74.9878 4.80635 74.9889 4.81569 74.9902C4.83437 74.9928 4.8613 74.9966 4.89629 75.0013C4.96627 75.0109 5.06848 75.0246 5.20134 75.0415C5.46706 75.0755 5.85548 75.1227 6.35401 75.177C7.3509 75.2855 8.78898 75.4222 10.5673 75.537C14.1214 75.7665 19.0471 75.9091 24.5329 75.5601C35.4308 74.8669 48.8577 72.2161 57.9951 64.1229L56.006 61.8772C47.6434 69.284 35.0699 71.8838 24.3424 72.5662C19.0155 72.905 14.2222 72.7667 10.7605 72.5433C9.03091 72.4316 7.63689 72.2989 6.67865 72.1946C6.19962 72.1424 5.82972 72.0974 5.58151 72.0657C5.45741 72.0499 5.36375 72.0373 5.3021 72.0289C5.27128 72.0247 5.24846 72.0215 5.23384 72.0195C5.22653 72.0184 5.22127 72.0177 5.21809 72.0172C5.21649 72.017 5.21542 72.0169 5.21487 72.0168C5.21459 72.0167 5.21457 72.0167 5.21443 72.0167C5.21454 72.0167 5.21478 72.0168 4.99969 73.5013ZM57.9951 64.1229C62.6358 60.0126 65.7797 54.2154 67.9125 47.9607C70.0488 41.6957 71.2059 34.8681 71.8063 28.5801C72.4072 22.2859 72.4543 16.4891 72.3517 12.2683C72.3004 10.1564 72.2115 8.43541 72.1352 7.2395C72.0971 6.64146 72.0621 6.17449 72.0364 5.85535C72.0236 5.69576 72.0131 5.57312 72.0057 5.48951C72.0021 5.4477 71.9992 5.41565 71.9971 5.39362C71.9961 5.3826 71.9954 5.37409 71.9948 5.36811C71.9945 5.36512 71.9943 5.36276 71.9941 5.36105C71.994 5.36019 71.994 5.35939 71.9939 5.35895C71.9939 5.35831 71.9938 5.35782 70.5006 5.50003C69.0073 5.64225 69.0073 5.64208 69.0073 5.64207C69.0073 5.64228 69.0074 5.64244 69.0074 5.64286C69.0075 5.64369 69.0076 5.64517 69.0078 5.64727C69.0082 5.65149 69.0088 5.65823 69.0097 5.66745C69.0114 5.68591 69.0139 5.71434 69.0173 5.75247C69.024 5.82874 69.0338 5.94383 69.0461 6.09565C69.0705 6.39931 69.1043 6.84982 69.1413 7.43049C69.2154 8.59201 69.3023 10.2734 69.3526 12.3412C69.4531 16.4797 69.4064 22.1517 68.8199 28.295C68.2327 34.4445 67.1085 41.0232 65.073 46.9925C63.034 52.9722 60.1154 58.2375 56.006 61.8772L57.9951 64.1229Z"
            fill="black"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_7470_122614"
            x="0.785645"
            y="0"
            width="85.623"
            height="79.7695"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7470_122614"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7470_122614"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Box>
  );
};

export default VectorLegends;
